import { render, staticRenderFns } from "./systemDock.vue?vue&type=template&id=7a090de8&scoped=true&"
import script from "./systemDock.vue?vue&type=script&lang=js&"
export * from "./systemDock.vue?vue&type=script&lang=js&"
import style0 from "./systemDock.vue?vue&type=style&index=0&id=7a090de8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a090de8",
  null
  
)

export default component.exports